import ENV from "../env";

const refreshInvoiceCheckoutSession = async (invoiceId) => {
  const response = await fetch(`${ENV.firebaseApiUrl}/stripe/invoice/${invoiceId}/refresh-session`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });

  const resData = await response.json();

  if (!response.ok) {
    const errorMessage = resData?.error || "Failed to refresh invoice checkout session";
    throw new Error(errorMessage);
  }

  return resData;
};

export default refreshInvoiceCheckoutSession;
